import React, { Component } from 'react'
import $ from 'jquery'
import url from './audio/gbqq.mp3' // Import the background music file


class Main extends Component {
    state = {
        date: {},
    }
    componentDidMount() {
        this.print();
        setInterval(() => {
            this.time(2023, 6, 5) // Updated anniversary date: June 5, 2023
        }, 1000
        )
        var audio = document.getElementById("audio");
        setTimeout(() => audio.play(), 8500) // Delay duration for background music playback after page load, unit: milliseconds.
    }
    print = () => {
        $.fn.autotype = function () {
            var _this = $(this);
            var str = _this.html();
            // Regex to replace multiple spaces added between lines of code
            str = str.replace(/(\s){2,}/g, "$1");
            var index = 0;
            $(this).html('');
            var timer = function fn() {
                var args = arguments;
                var current = str.slice(index, index + 1);
                if (current == '<') {
                    index = str.indexOf('>', index) + 1;
                }
                else {
                    index++;
                }
                if (index < str.length - 1) { 
                    _this.html(str.substring(0, index) + (index & 1 ? '_' : ''));
                } else {
                    _this.html(str.substring(0, index));
                    clearTimeout(timer);
                };
                setTimeout(fn, 200)
            };
            setTimeout(timer, 1000);
        };
        $("#autotype").autotype();
    }
    time = (year, month, day) => {
        var dateNow = new Date();
        var dateJNR = new Date(year, month - 1, day);
        var d = parseInt((dateNow - dateJNR) / (24 * 3600 * 1000));
        var hour = parseInt(((dateNow - dateJNR) / (3600 * 1000)) % 24);
        var minute = parseInt((dateNow - dateJNR) / (1000 * 60) % 60);
        var second = parseInt((dateNow - dateJNR) / 1000 % 60);
        this.setState({ date: { d: d, hour: hour, minute: minute, second: second } });
    };
    render() {
        const date = () => {
            if (this.state.date.d !== undefined) {
                const { d, hour, minute, second } = this.state.date
                return (
                    <p style={{ margin: '0', fontWeight: 'bold' }}>
                        We have been together for: <span className="date-text">{d}</span> Days <span className="date-text">{hour}</span> Hours <span className="date-text">{minute}</span> Mins <span className="date-text">{second}</span> Secs
                    </p>
                )
            }
        }
        return (
            <div className="App animated bounceInLeft" style={{ display: 'flex', flexDirection: 'column', }}>
                
                {/* Autotype handles ONLY the static message text now */}
                <div id="autotype">
                    <h1 style={{ fontWeight: 900, marginTop: '80px' }}>Happy 3rd Anniversary! 🎉</h1>
                    
                    <p>Three beautiful years together! Every single day with you is my favorite day. ❤️</p>
                    
                    <p>Thank you for being my happiness. Happy anniversary, my love! 💕</p>
                </div>

                {/* The countdown is safely separated outside autotype so React can update it smoothly */}
                <div className="date" style={{ paddingLeft: '10px', marginTop: '15px' }}>
                    {date()}
                </div>
                
                {/* The date block is also outside to maintain the structural layout below the timer */}
                <div style={{ textAlign: 'right', marginTop: '20px', paddingRight: '20px' }}>
                    <p style={{ margin: '0', fontWeight: 'bold' }}>June 5, 2026</p>
                </div>

                <audio id="audio" src={url}></audio>
            </div>

        )
    }
}
export default Main


// WEBPACK FOOTER //
// ./src/Main.js